import React, {useState} from 'react';
import {useEffect} from 'react';
import env from '../../.././util/env';
import {getPermissionGroups, resetPermissionGroup} from '../../../actions/admin/permissiongroupsactions';
import {pagingOptions, currentResource} from '../../../../src/util/uiconstants';
import Pagination from '../../Common/Pagination/PaginationMotif';
import {useSelector, useDispatch} from 'react-redux';
import Table from '@ey/motif-react-wrapper/Table';
import EllipsesControl from '../../Common/EllipsesControl/EllipsesControl';
import Loader from '../../Common/Loaders/loadingindicator';
import {Link} from 'react-router-dom';
import {labels} from '../../../util/uiconstants';
import AccessDeniedMessage from '../../Common/AccessDeniedMessage/AccessDeniedMessage';
import Wrapper from '../permissiongroups/styles/permissiongroupsbasestyle';
import {clearErrors} from '../../../actions/erroractions';
import {setIsModalOpen} from '../../../actions/modalstateactions';

function PermissionGroup() {
	const columnDefs = [
		{
			flex: 4,
			headerName: labels.permissionGroupName,
			field: 'groupname',
			cellRenderer: (params) => groupNameCellRenderer(params),
			lockPosition: true,
			suppressSizeToFit: true
		},
		{
			flex: 4,
			headerName: labels.permissionGroupDescription,
			field: 'groudescription',
			cellRenderer: (params) => groupDecriptionCellRenderer(params),
			lockPosition: true,
			suppressSizeToFit: true
		},
		{
			flex: 4,
			headerName: labels.activeMembers,
			field: 'activemembers',
			cellRenderer: (params) => activeMembersCellRenderer(params),
			lockPosition: true,
			suppressSizeToFit: true
		}
	];

	const groupNameCellRenderer = (e) => {
		return (
			<section className="roleType groupName-cell motif-body2-default-light">
				<Link
					className="groupname"
					to={{
						pathname:
							'/admin/permissiongroups/' + e.data?.activeDirectoryGroupID,
						state: {customLabel: e.data?.activeDirectoryGroupName}
					}}
				>
					<EllipsesControl
						content={e.data?.activeDirectoryGroupName}
						tooltip={e.data?.activeDirectoryGroupName}
						displayId={''}
						noOfLines={1}
						ellipsisClass="columnName"
					/>
				</Link>
			</section>
		);
	};

	const groupDecriptionCellRenderer = (e) => {
		return (
			<section className="roleType motif-body2-default-light">
				<EllipsesControl
					content={e.data?.activeDirectoryGroupDescription}
					tooltip={e.data?.activeDirectoryGroupDescription}
					displayId={''}
					noOfLines={1}
				/>
			</section>
		);
	};

	const activeMembersCellRenderer = (e) => {
		return (
			<section className="roleType motif-body2-default-light">
				{e.data?.activeUserCount}
			</section>
		);
	};

	const permissionGroup = useSelector((store) => store.permissionGroup);
	const userPermissions = useSelector((store) => store.userPermissions);
	const [optionPerPage, setOptionPerPage] = useState(pagingOptions.options[0]);
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState();
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch(0);

	useEffect(() => {
		setLoading(true);
		dispatch(resetPermissionGroup());
		let permissionGroupUrl =
			env.getURL('serviceUrlV2') + 'admin/PermissionGroups';
		dispatch(getPermissionGroups(permissionGroupUrl))
			.then(() => {
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
			});
	}, []);

	// Use common error clearing framework to clear axios errors
	const clearError = (isModelOpen) => {
		dispatch(clearErrors()).then(() => {
			dispatch(setIsModalOpen(isModelOpen));
		});
	};

	useEffect(()=>{
		clearError(true);
	},[])

	useEffect(() => {
		var pages =
			permissionGroup.length % optionPerPage == 0
				? permissionGroup.length / optionPerPage
				: (permissionGroup.length - (permissionGroup.length % optionPerPage)) /
						optionPerPage +
				  1;
		setTotalPages(pages);
	}, [optionPerPage, permissionGroup]);

	const paginationHandler = (value) => {
		if (page !== value && page > 0) {
			setPage(value);
		}
	};

	const handlerOptionPage = (value) => {
		if (value !== optionPerPage) {
			setOptionPerPage(value);
			setPage(1);
		}
	};

	function adminPermissions() {
		let permissionGroupPermission = userPermissions?.permissions;
		return (
			permissionGroupPermission &&
			(permissionGroupPermission.canReadPermissionsGroups ||
				permissionGroupPermission.canSyncPermissionsGroups ||
				permissionGroupPermission.canCreateUpdatePermissionsGroups)
		);
	}
	
	const getRowStyle = (params) => {
		if (params.node.rowIndex % 2 === 0) {
			return {background: 'var(--neutrals-00white)'};
		} else {
			return {background: 'var(--ui-background-secondary)'};
		}
	};

	return (
		<Wrapper>
			{loading == true ? (
				<Loader show view="blockView" styleName="loadingstyle" />
			) : (
				<section className="mainwrapper">
					{adminPermissions() ? (
						permissionGroup ? (
							<section>
								<section className="permissiongroup mainResponsiveWrapper">
									<section className="managepermissionTable">
										<Table
											defaultColDef={{
												flex: 1,
												sortable: false,
												filter: false,
												resizable: false,
												minWidth: 180,
												lockPosition: true
											}}
											onGridReady={(params) => {
												params.api.sizeColumnsToFit();
											}}
											getRowStyle={getRowStyle}
											rowHeight={48}
											headerHeight={48}
											enableCellTextSelection
											suppressCellSelection
											columnDefs={columnDefs}
											rowSelection="multiple"
											rowData={Array.from(permissionGroup).slice(
												(page - 1) * optionPerPage,
												page * optionPerPage
											)}
											rowBuffer={200}
										/>
									</section>
								</section>
							</section>
						) : (
							<section className="message">
								<h5>{labels.serverErrorMessage}</h5>
							</section>
						)
					) : (
						<section className="message">
							<AccessDeniedMessage
								permissionMesage={labels.insufficientPermission}
							/>
						</section>
					)}
				</section>
			)}

			{!loading && <section className="pagerholder">
				<Pagination
					styleName="messaging-paging mainResponsiveWrapper"
					options={pagingOptions.options}
					pageSize={optionPerPage}
					showText={currentResource.common.pagination.show}
					onPageSizeChange={(pageSize) => {
						handlerOptionPage(pageSize);
					}}
					totalPages={totalPages}
					currentPage={page}
					onPageChange={(pageNumber) => {
						paginationHandler(pageNumber);
					}}
				/>
			</section>}
		</Wrapper>
	);
}

export default PermissionGroup;
